/**
 * Product type constants used throughout the application
 */
export enum ProductType {
  BUNDLE_CONTAINER = 'Bundle Container',
  GIFT_CARDS = 'Gift Cards',
  GREETING_CARDS = 'Greeting Cards',
  GIFT_WRAPPING = 'Gift Wrapping',
  HAMPER = 'Hampers'
}

/**
 * Shipping types
 */
export enum ShippingType {
  SINGLE = 'SINGLE',
  MULTI = 'MULTI'
}